import { OnlineProvider } from "@api/enums/Session/OnlineProviderEnum";
import { dateInOriginalOffset } from "@common/dateTimeHelper";
import { DateTime } from "luxon";
import { AgendaModel } from "../agenda/AgendaModel";
import { MultiLangObjectModel } from "../common/MultiLangObjectModel";
import { SessionOnlineParams } from "../interfaces/session/OnlineParams";
import { SessionEditModelInterface } from "../interfaces/session/SessionEditModelInterface";

export class SessionEditModel extends MultiLangObjectModel implements SessionEditModelInterface {
    id?: string;
    onlineProvider?: OnlineProvider = "";
    title = "";

    eventId: string;

    beginAt?: DateTime | null = null;
    endAt?: DateTime | null = null;
    updatedAt?: string = undefined;

    speakerUserIds: number[] = [];
    description = "";
    partnerId: string | null = null;
    tagsIds?: string[] | null = [];
    type = "";
    groupIds: string[] = [];

    private onlineParams: SessionOnlineParams = {};

    $_multiLangFields = [
        'title',
        'description',
        'type'
    ];

    #copy: string | null = null;

    constructor(data: { [lang: string]: AgendaModel }, speakerUserIds: (number | undefined)[], offset: string | null = null) {

        super();

        const res: { [key: string]: any } = {};

        this.$_multiLangFields.forEach((field) => {

            let lang: keyof typeof data;

            for (lang in data) {
                res[`${field}.${lang}`] = data[lang][field] || null;
            }
        })

        Object.assign(this, res)

        const source = data[Object.keys(data)[0]];

        //prevent filling if data is empty
        if (source && Object.keys(source).length) {
            Object.assign(this, {
                id: source.id,
                onlineProvider: source.onlineProvider,
                onlineParams: source.onlineParams,
                title: source.title,
                beginAt: offset ? dateInOriginalOffset(source.beginAt, parseInt(offset)) : source.beginAt,
                endAt: offset ? dateInOriginalOffset(source.endAt, parseInt(offset)) : source.endAt,
                updatedAt: source.updatedAt,
                speakerUserIds: speakerUserIds,
                description: source.description,
                partnerId: source.partnerId,
                tagsIds: source.tagsIds,
                type: source.type,
                groupIds: source.groupIds
            })
        }

        this.resetCopy();
    }

    resetCopy() {
        this.#copy = JSON.stringify(this);
    }

    /**
     * reset fields to init values
     */
    reset() {
        Object.assign(this, JSON.parse(this.#copy || ""));
    }

    get needReset() {
        return JSON.stringify(this) !== this.#copy;
    }

    get link() {
        if (this.onlineProvider === OnlineProvider.webConference) {return "";}
        return (this.onlineParams.youtube && this.onlineParams.youtube.url) ||
            (this.onlineParams.custom && this.onlineParams.custom.url) ||
            (this.onlineParams.webconference && this.onlineParams.webconference.url) ||
            (this.onlineParams.pastsessionrecord && this.onlineParams.pastsessionrecord.url) || ""
    }

    set link(value: string) {
        if (this.onlineProvider === OnlineProvider.youTube) {
            this.onlineParams = {
                youtube: { url: value },
                simulInterpretation: { url: "" }
            }
        }

        if (this.onlineProvider === OnlineProvider.youTubeRecord || this.onlineProvider === OnlineProvider.custom) {
            this.onlineParams = {
                custom: { url: value },
                simulInterpretation: { url: "" }
            }
        }

        if (this.onlineProvider === OnlineProvider.webConference) {
            this.onlineParams = {
                webconference: { url: value },
                simulInterpretation: { url: "" }
            }
        }

        if (this.onlineProvider === OnlineProvider.pastSessionRecord) {
            this.onlineParams = {
                pastsessionrecord: { url: value },
                simulInterpretation: { url: "" }
            }
        }

        if(!this.onlineProvider) {
            this.onlineParams = {
                custom: { url: value },
            }
        }
    }
}